/** Not-loaded error. */
export default class NotLoadedError extends Error {}
